import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { userApi, userClientSlice, clientApi, userClientApi } from './user';
import { projectAPI } from './project';
import { courseApi } from './course';
import { skillsApi } from './skills';
import { calendarApi } from './calendar';
import { notificationApi } from './notifications/notification-api';
import { publicAdminApi } from './public';
import storage from 'redux-persist/lib/storage';
import {
  // FLUSH,
  // PAUSE,
  // PERSIST,
  persistReducer,
  // PURGE,
  // REGISTER,
  // REHYDRATE,
} from 'redux-persist';
import persistStore from 'redux-persist/es/persistStore';
//

export const APP_RESET = 'app/reset' as const;

const userClientPersistConfig = {
  key: 'userClientData',
  storage,
  whitelist: ['tenant', 'wizardData', 'wizardStep'],
};

const persistedUserClientReducer = persistReducer(
  userClientPersistConfig,
  userClientSlice.reducer
);

// Combine reducer
const appReducer = combineReducers({
  [userApi.reducerPath]: userApi.reducer,
  [clientApi.reducerPath]: clientApi.reducer,
  [projectAPI.reducerPath]: projectAPI.reducer,
  [courseApi.reducerPath]: courseApi.reducer,
  [userClientApi.reducerPath]: userClientApi.reducer,
  [skillsApi.reducerPath]: skillsApi.reducer,
  [calendarApi.reducerPath]: calendarApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [publicAdminApi.reducerPath]: publicAdminApi.reducer,

  userClientData: persistedUserClientReducer,
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === APP_RESET) {
    state = undefined; //  clears all redux state (including RTK Query slices)
  }
  return appReducer(state, action);
};

// Store setup
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        userApi.middleware,
        courseApi.middleware,
        clientApi.middleware,
        userClientApi.middleware,
        projectAPI.middleware,
        skillsApi.middleware,
        calendarApi.middleware,
        notificationApi.middleware,
        publicAdminApi.middleware
      ),
  });
};

export type RootState = ReturnType<typeof appReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

export const store = setupStore();
export const persistor = persistStore(store);

export const hardResetStore = async (dispatch: AppDispatch) => {
  await persistor.purge(); // clears localStorage persisted redux-persist keys
  dispatch({ type: APP_RESET }); //  resets in-memory redux state
};
